// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/assets/fonts/open-sans-v35-latin-300.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/assets/fonts/open-sans-v35-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/assets/fonts/open-sans-v35-latin-600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/assets/fonts/open-sans-v35-latin-700.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* open-sans-300 - latin */
@font-face {
  font-display: swap;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
}
/* open-sans-regular - latin */
@font-face {
  font-display: swap;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
}
/* open-sans-500 - latin */
@font-face {
  font-display: swap;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}
/* open-sans-700 - latin */
@font-face {
  font-display: swap;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
}
header {
  max-width: 1270px;
  margin: auto;
}
header .inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 1024px) {
  header .inner {
    padding: 0 20px;
  }
}
header .inner .logo img {
  max-height: 40px;
  margin-top: 5px;
}
header .inner .buttons a {
  margin-left: 25px;
}
header .inner .buttons a img {
  height: 24px;
  width: auto;
  transition: all 0.2s ease-in-out;
}
header .inner .buttons a:hover img {
  opacity: 0.5;
}

body {
  font-family: "Open Sans";
  box-sizing: border-box;
  color: #17283f;
  padding: 0;
  margin: 0;
}
body * {
  box-sizing: border-box;
}

.cnt {
  max-width: 1270px;
  margin: auto;
  padding: 40px 0;
  padding-bottom: 0;
}
@media (max-width: 1024px) {
  .cnt {
    padding: 40px 20px;
  }
}
.cnt .questions > .inner {
  padding-right: 40px;
}
@media (max-width: 1024px) {
  .cnt .questions > .inner {
    padding-right: 0;
  }
}

.steps {
  background-color: #f9f5f0;
  width: 100%;
  padding: 20px 0;
}
@media (max-width: 1024px) {
  .steps {
    padding: 20px 20px;
  }
}
.steps .inner {
  max-width: 1270px;
  margin: auto;
}
.steps .control {
  display: flex;
  align-items: center;
  max-width: 700px;
  margin: auto;
}
.steps .arrow {
  flex: 0 0 10%;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.steps .arrow.disabled {
  opacity: 0.5;
  cursor: default;
}
.steps .arrow.disabled:hover {
  opacity: 0.5;
}
.steps .arrow:hover {
  opacity: 0.75;
}
.steps .arrow img {
  max-height: 40px;
  width: auto;
}
.steps .arrow.prev {
  margin-bottom: -4px;
}
.steps .arrow.next {
  transform: rotate(180deg);
  margin-top: -4px;
}
.steps .numsteps {
  flex: 1 0 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  max-width: 500px;
  margin: auto;
}
.steps .numsteps:after {
  position: absolute;
  content: "";
  width: 100%;
  height: 4px;
  background-color: white;
}
.steps .centre_block {
  width: 55px;
  height: 55px;
  justify-content: center;
  align-items: flex-start;
  display: flex;
}
.steps .centre_block.selected .centre_icon_wrap {
  background-color: #1a8992;
}
.steps .centre_block.selected .centre_icon_wrap p {
  color: white;
}
.steps .centre_icon_wrap {
  z-index: 5;
  width: 55px;
  height: 55px;
  background-color: #fff;
  border-radius: 50px;
  justify-content: center;
  align-items: center;
  padding: 10px 10px;
  display: flex;
  position: relative;
  box-shadow: 0 0 7px -1px rgba(51, 51, 51, 0.15);
}
.steps .span-bleu-small {
  color: #1a8992;
  text-align: left;
  font-size: 2em;
  font-weight: 700;
  line-height: 1.5;
}

.step .separator {
  display: grid;
  grid-template-columns: 100px 1fr;
  grid-gap: 30px;
}
@media (max-width: 1024px) {
  .step .separator {
    grid-template-columns: 0px 1fr;
  }
}
.step .separator .line {
  border-top: 3px dashed #e0ddd8;
  margin-bottom: 60px;
}

.questions {
  display: grid;
  grid-template-columns: 100px 1fr;
  grid-gap: 30px;
}
@media (max-width: 1024px) {
  .questions {
    grid-template-columns: 1fr;
  }
}
.questions .side {
  display: flex;
  align-content: center;
  align-items: center;
}
.questions .side .label {
  color: #e0ddd8;
  transform: rotate(-90deg);
  font-weight: bold;
  font-size: 32px;
  text-transform: uppercase;
}
@media (max-width: 1024px) {
  .questions .side .label {
    transform: rotate(0deg);
  }
}
.questions .side .label.higher {
  margin-left: -40px;
}
@media (max-width: 1024px) {
  .questions .side .label.higher {
    margin: 0%;
  }
}
.questions .inner {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 30px;
  margin-bottom: 60px;
}
@media (max-width: 1024px) {
  .questions .inner {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (max-width: 768px) {
  .questions .inner {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 428px) {
  .questions .inner {
    grid-template-columns: 1fr;
  }
}
.questions.five .inner {
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}
@media (max-width: 1024px) {
  .questions.five .inner {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (max-width: 768px) {
  .questions.five .inner {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 428px) {
  .questions.five .inner {
    grid-template-columns: 1fr;
  }
}
.questions.six .inner {
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}
@media (max-width: 1024px) {
  .questions.six .inner {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (max-width: 768px) {
  .questions.six .inner {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 428px) {
  .questions.six .inner {
    grid-template-columns: 1fr;
  }
}
.questions .question {
  display: inline-block;
  margin-bottom: 0px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  position: relative;
}
.questions .question:hover {
  opacity: 0.75;
}
.questions .question.selected {
  background: #1a8992;
  color: white;
}
.questions .question.selected:hover {
  opacity: 1;
}
.questions .question .image {
  width: 100%;
  position: relative;
  min-height: 200px;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 10px;
}
@media (max-width: 1280px) {
  .questions .question .image {
    min-height: 160px;
  }
}
.questions .question .image img {
  max-width: 100%;
  border-radius: 10px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.questions .question .image .title-holder {
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  width: 100%;
}
.questions .question .image .title-holder h4 {
  background: white;
  display: inline-block;
  font-size: 14px;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 600;
}
.questions .question > img {
  max-width: 100%;
  border-radius: 10px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.questions .question h4 {
  margin: 0;
  padding: 2px 6px;
  font-weight: 500;
  position: absolute;
  background: #fff;
  border-radius: 4px;
  top: 6px;
  left: 6px;
  font-weight: 600;
  font-size: 14px;
}
.questions .question .mark {
  position: absolute;
  top: 0;
  right: 0;
  background: white;
  padding: 5px;
  border-bottom-left-radius: 10px;
  z-index: 6;
  display: none;
}
.questions .question .mark img {
  height: 26px;
  background: white;
  border-bottom-left-radius: 10px;
}
.questions .question .mark .close {
  display: none;
}
.questions .question .mark:hover .sqm {
  display: none;
}
.questions .question .mark:hover .close {
  display: block;
  cursor: pointer;
}
.questions .question .subitems {
  width: 100%;
  font-size: 12px;
  display: none;
  padding: 0;
}
.questions .question .subitems.active {
  display: block;
}
.questions .question .selectedroom {
  position: absolute;
  top: 35px;
  left: 6px;
  background: #fff;
  padding: 3px;
  z-index: 2;
  border-radius: 4px;
  font-size: 10px;
}
.questions .question.sqmselect {
  cursor: default;
  position: relative;
}
.questions .question.sqmselect .roomselector {
  display: none;
  background: white;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  border-radius: 10px;
  text-align: center;
  font-size: 13px;
  padding: 20px;
}
.questions .question.sqmselect .roomselector .title {
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: bold;
}
.questions .question.sqmselect .roomselector .rooms .room {
  cursor: pointer;
  padding: 2px 0;
  text-transform: capitalize;
}
@media (max-width: 1024px) {
  .questions .question.sqmselect .roomselector .rooms .room {
    font-size: 18px;
    padding-bottom: 5px;
  }
}
.questions .question.sqmselect .roomselector .rooms .room:hover {
  text-decoration: underline;
}
.questions .question.sqmselect.hasroom {
  box-shadow: 0 0 7px -1px rgba(51, 51, 51, 0.15);
}
.questions .question.sqmselect.hasroom .roomselector {
  display: none !important;
}
.questions .question.sqmselect.hasroom .image {
  cursor: default;
}
.questions .question.sqmselect.hasroom .message {
  display: none !important;
}
.questions .question.sqmselect.hasselectionprocess .roomselector {
  display: block;
}
.questions .question.sqmselect.hasselectionprocess .message {
  display: none !important;
}
.questions .question.sqmselect .tip {
  border: 0;
  font-size: 10px;
  background: #1a8992;
  border-radius: 100%;
  width: 12px;
  height: 12px;
  padding: 0;
  margin-left: 5px;
  color: white;
}
.questions .question.sqmselect .message {
  display: flex;
  background: white;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  border-radius: 10px;
  text-align: center;
  font-size: 13px;
  padding: 20px;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.2s ease-in-out;
  pointer-events: none;
  font-weight: bold;
  max-height: 260px;
}
.questions .question.sqmselect .image {
  min-height: 260px;
  cursor: pointer;
}
.questions .question.sqmselect:hover {
  opacity: 1;
}
.questions .question.sqmselect:hover .message {
  opacity: 0.6;
  display: flex;
}
.questions .question.sqmselect .rw-widget-input {
  font-size: 12px;
  min-width: 35px;
}
@media (max-width: 1024px) {
  .questions .question.sqmselect .rw-widget-input {
    font-size: 16px;
  }
}
@media (max-width: 1024px) {
  .questions.rooms .inner {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (max-width: 768px) {
  .questions.rooms .inner {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 428px) {
  .questions.rooms .inner {
    grid-template-columns: 1fr;
  }
}
.questions.rooms .image {
  border-radius: 10px;
}
.questions .hasnumbers .mark {
  display: block;
}
.questions .sub {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 60px;
  flex-wrap: wrap;
  padding: 6px;
}
.questions .sub .row {
  width: 100%;
  flex: 1 0 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 6px 6px;
  font-size: 14px;
}
@media (max-width: 1024px) {
  .questions .sub .row {
    margin-bottom: 20px;
  }
}
.questions .sub .row p {
  margin: 0;
  padding: 0;
  line-height: 15px;
}
.questions .sub .row .title {
  flex: 1 0 40%;
}
.questions .sub .row.wallsize {
  flex-wrap: wrap;
}
.questions .sub .row .newline {
  flex: 1 0 100%;
  margin-top: 8px;
}
.questions .sub .row .newline .inpts {
  width: 100%;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}
.questions .sub .row .newline .inpts strong {
  margin-right: 5px;
  margin-left: 5px;
}
.questions .sub .row.spoiler {
  display: flex;
  overflow: hidden;
  transition: opacity 0.3s ease-in-out;
  font-size: 13px;
}
@media (max-width: 1024px) {
  .questions .sub .row.spoiler {
    font-size: 14px;
    padding-bottom: 0px;
  }
}
.questions .sub .row.hidden {
  display: none;
}
.questions .sub .rw-number-picker {
  max-width: 80px;
}
@media (max-width: 1024px) {
  .questions .sub .rw-number-picker {
    max-width: 130px;
  }
}
.questions .sub .rw-number-picker .rw-widget-picker {
  min-height: 30px;
  grid-template: 1fr/1fr 2em;
}
@media (max-width: 1024px) {
  .questions .sub .rw-number-picker .rw-widget-picker {
    min-height: 40px;
    grid-template: 1fr/1fr 3em;
  }
}
.questions .sub h4 {
  padding: 0px;
  font-size: 16px;
}
.questions .sub .right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
.questions .sqm {
  max-height: 30px;
}
.questions .sqm.small {
  max-height: 20px;
  margin-right: 5px;
}

.inputs.noradio {
  display: flex;
  flex: 1 0 12%;
  justify-content: flex-end;
}
.inputs.noradio label {
  font-size: 12px;
  line-height: 12px;
  background: #fff;
  padding: 2px 6px;
  border: 1px solid #1a8992;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .inputs.noradio label {
    font-size: 18px;
    border: 0;
    border-radius: 8px;
  }
}
.inputs.noradio input[type=radio] {
  display: none;
}
.inputs.noradio input[type=radio]:checked + label {
  background-color: #1a8992;
  color: white;
}
.inputs.noradio .smallicon {
  max-width: 20px;
  padding: 2px;
  margin-right: 4px;
  opacity: 0.6;
}
@media (max-width: 1024px) {
  .inputs.noradio .smallicon {
    max-width: 30px;
    padding: 2px;
    margin-right: 6px;
    opacity: 0.6;
    margin-top: -8px;
  }
}
.inputs.noradio > div:nth-child(2) label {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-right: 0;
}
@media (max-width: 1024px) {
  .inputs.noradio > div:nth-child(2) label {
    border-radius: 8px;
  }
}
.inputs.noradio > div:last-child label {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-left: none;
}
@media (max-width: 1024px) {
  .inputs.noradio > div:last-child label {
    border-radius: 8px;
  }
}
.step-form {
  text-align: center;
}

.form {
  max-width: 600px;
  margin: auto;
  box-shadow: 0 0 7px -1px rgba(51, 51, 51, 0.15);
  padding: 30px;
  border-radius: 10px;
  margin-top: 40px;
  text-align: left;
  margin-bottom: 60px;
  background: #f9f5f0;
}
.form > div {
  margin-bottom: 10px;
}
.form label {
  width: 100%;
  display: inline-block;
  margin-bottom: 5px;
}
.form .error {
  color: red;
}
.form input, .form select, .form textarea {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
}
.form input {
  width: 100%;
}
.form select {
  width: 100%;
}
.form textarea {
  width: 100%;
}
.form button {
  color: #f8f9fb;
  white-space: nowrap;
  background-color: #205e63;
  border-radius: 3px;
  margin: 0;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 600;
  border: 0;
  line-height: 1.5;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.form button:hover {
  color: #fff;
  background-color: #10383b;
  box-shadow: 0 1px 8px rgba(57, 64, 72, 0.4);
}
.form button.disabled {
  cursor: default;
  opacity: 0.5;
}
.form .radios input {
  width: auto;
  margin-left: 10px;
}
.form .radios label {
  width: auto;
}

.pdf .elements {
  display: flex;
  grid-gap: 30px;
  margin-bottom: 60px;
}
@media (max-width: 1024px) {
  .pdf .elements {
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
}
.pdf .button {
  color: #f8f9fb;
  white-space: nowrap;
  background-color: #205e63;
  border-radius: 3px;
  margin: 0;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 600;
  border: 0;
  line-height: 1.5;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  max-width: 180px;
  margin: 0px;
  text-align: center;
}
.pdf .button:hover {
  color: #fff;
  background-color: #10383b;
  box-shadow: 0 1px 8px rgba(57, 64, 72, 0.4);
}
.pdf .button.disabled {
  cursor: default;
  opacity: 0.5;
}
.pdf .message {
  flex: 1 0 30%;
  font-size: 14px;
  background: #f9f5f0;
  padding: 30px;
}
@media (max-width: 1024px) {
  .pdf .message {
    flex: 1 0 100%;
  }
}
.pdf .message img {
  max-width: 100%;
  border-radius: 10px;
}
.pdf .message button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.pdf .message button img {
  max-height: 20px;
  margin-right: 5px;
  width: auto;
  filter: invert(1);
}
.pdf iframe {
  flex: 1 0 60%;
  width: 100%;
  min-height: 600px;
  border: 0;
}
@media (max-width: 1024px) {
  .pdf iframe {
    flex: 1 0 100%;
  }
}

@media (max-width: 1024px) {
  .popup-content {
    width: 100%;
  }
}

.modl {
  min-height: 40vh;
  padding: 30px;
}
.modl .close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 32px;
  z-index: 22;
  line-height: 12px;
}
.modl .dates {
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  column-gap: 20px;
}
.modl .dates .rw-date-picker {
  width: 40%;
  margin-bottom: 20px;
}
.modl .dates .rw-time-input {
  max-height: 40px;
}
.modl .button {
  color: #f8f9fb;
  white-space: nowrap;
  background-color: #205e63;
  border-radius: 3px;
  margin: 0;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 600;
  border: 0;
  line-height: 1.5;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  max-width: 280px;
  margin: 0px;
  text-align: center;
  display: inline-block;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-height: 42px;
  margin-top: 20px;
}
.modl .button:hover {
  color: #fff;
  background-color: #10383b;
  box-shadow: 0 1px 8px rgba(57, 64, 72, 0.4);
}
.modl .button.disabled {
  cursor: default;
  opacity: 0.5;
}
@media (max-width: 1024px) {
  .modl .button {
    font-size: 13px;
  }
}
.modl .button img {
  max-height: 20px;
  margin-right: 5px;
  width: auto;
  filter: invert(1);
}
.modl .buttons {
  display: flex;
  flex-wrap: wrap;
}
.modl p a {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;
}
.modl p a img {
  max-height: 20px;
  width: auto;
  margin-right: 6px;
}

.popup-overlay {
  background: rgba(0, 0, 0, 0.8);
}

.pdf-viewer {
  display: flex;
  flex-wrap: wrap;
}
.pdf-viewer .ui {
  display: block;
  width: 100%;
  padding: 20px;
}
.pdf-viewer .ui textarea {
  width: 100%;
  min-height: 100px;
}
.pdf-viewer .pdf-window {
  display: block;
  width: 100%;
}

.pdf-window {
  flex: 1 0 70%;
  display: block;
}
@media (max-width: 1024px) {
  .pdf-window {
    display: none;
  }
}
@media all and (device-width: 1024px) {
  .pdf-window {
    display: none;
  }
}
@media all and (device-width: 768px) {
  .pdf-window {
    display: none;
  }
}

.pdf-download {
  margin-bottom: 30px;
}
@media (max-width: 1024px) {
  .pdf-download {
    display: block;
    width: 100%;
    text-align: center;
    margin-bottom: 60px;
  }
}
@media all and (device-width: 1024px) {
  .pdf-download {
    display: block;
    width: 100%;
    text-align: center;
  }
}
@media all and (device-width: 768px) {
  .pdf-download {
    display: block;
    width: 100%;
    text-align: center;
  }
}
.pdf-download a {
  display: flex;
  justify-content: center;
  text-decoration: none;
}
.pdf-download img {
  max-height: 50px;
  border-radius: 6px;
  margin-right: 20px;
}

.bottom-navigation {
  max-width: 1270px;
  margin: auto;
}
.bottom-navigation .control {
  display: flex;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}
.bottom-navigation .button {
  color: #f8f9fb;
  white-space: nowrap;
  background-color: #205e63;
  border-radius: 3px;
  margin: 0;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 600;
  border: 0;
  line-height: 1.5;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  max-width: 300px;
  margin: 0 14px;
}
.bottom-navigation .button:hover {
  color: #fff;
  background-color: #10383b;
  box-shadow: 0 1px 8px rgba(57, 64, 72, 0.4);
}
.bottom-navigation .button.disabled {
  cursor: default;
  opacity: 0.5;
}
@media (max-width: 1024px) {
  .bottom-navigation {
    position: fixed;
    background: white;
    width: 100%;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bottom-navigation .control {
    margin: 20px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/fonts.scss","webpack://./src/scss/index.scss","webpack://./src/scss/header.scss","webpack://./src/scss/mixins.scss","webpack://./src/scss/layout.scss","webpack://./src/scss/steps.scss","webpack://./src/scss/questions.scss","webpack://./src/scss/form.scss","webpack://./src/scss/pdf.scss","webpack://./src/scss/bottomnavigation.scss"],"names":[],"mappings":"AAAE,0BAAA;AACA;EACE,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4DAAA;ACCJ;ADEE,8BAAA;AACA;EACE,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4DAAA;ACAJ;ADGE,0BAAA;AACA;EACE,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4DAAA;ACDJ;ADIE,0BAAA;AACA;EACE,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4DAAA;ACFJ;AC/BA;ECKI,iBAAA;EACA,YAAA;AF6BJ;AChCI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;ADkCR;AChCQ;EALJ;IAMQ,eAAA;EDmCV;AACF;AChCY;EACI,gBAAA;EACA,eAAA;ADkChB;AC7BY;EACI,iBAAA;AD+BhB;AC9BgB;EACI,YAAA;EACA,WAAA;EACA,gCAAA;ADgCpB;AC5BoB;EACI,YAAA;AD8BxB;;AG5DA;EACI,wBAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;AH+DJ;AG7DI;EACI,sBAAA;AH+DR;;AG3DA;EDPI,iBAAA;EACA,YAAA;ECQA,eAAA;EACA,iBAAA;AH+DJ;AG7DI;EALJ;IAMQ,kBAAA;EHgEN;AACF;AG9DI;EACI,mBAAA;AHgER;AG9DQ;EAHJ;IAIQ,gBAAA;EHiEV;AACF;;AI3FA;EACI,yBAAA;EACA,WAAA;EACA,eAAA;AJ8FJ;AI5FI;EALJ;IAMQ,kBAAA;EJ+FN;AACF;AI7FI;EFJA,iBAAA;EACA,YAAA;AFoGJ;AI5FI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AJ8FR;AI3FI;EACI,aAAA;EACA,eAAA;EACA,gCAAA;AJ6FR;AI3FQ;EACI,YAAA;EACA,eAAA;AJ6FZ;AI3FY;EACI,YAAA;AJ6FhB;AIzFQ;EACI,aAAA;AJ2FZ;AIvFQ;EACI,gBAAA;EACA,WAAA;AJyFZ;AIrFQ;EACI,mBAAA;AJuFZ;AIpFQ;EACI,yBAAA;EACA,gBAAA;AJsFZ;AIlFI;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AJoFR;AIlFQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;AJoFZ;AIhFI;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;AJkFR;AI/EY;EAEI,yBAAA;AJgFhB;AI/EgB;EACI,YAAA;AJiFpB;AI3EI;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,+CAAA;AJ6ER;AI1EI;EACI,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AJ4ER;;AItEI;EACI,aAAA;EACA,gCAAA;EACA,cAAA;AJyER;AIvEQ;EALJ;IAMQ,8BAAA;EJ0EV;AACF;AIvEQ;EACI,8BAAA;EACA,mBAAA;AJyEZ;;AK1MA;EAEI,aAAA;EACA,gCAAA;EACA,cAAA;AL4MJ;AK1MI;EANJ;IAOQ,0BAAA;EL6MN;AACF;AK3MI;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;AL6MR;AK3MQ;EACI,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AL6MZ;AK3MY;EAPJ;IAQQ,uBAAA;EL8Md;AACF;AK5MY;EACI,kBAAA;AL8MhB;AK5MgB;EAHJ;IAIQ,UAAA;EL+MlB;AACF;AK1MI;EACI,aAAA;EACA,sCAAA;EACA,cAAA;EACA,mBAAA;AL4MR;AK1MQ;EANJ;IAOQ,kCAAA;EL6MV;AACF;AK3MQ;EAVJ;IAWQ,0BAAA;EL8MV;AACF;AK5MQ;EAdJ;IAeQ,0BAAA;EL+MV;AACF;AK5MI;EACI,0CAAA;AL8MR;AK5MQ;EAHJ;IAIQ,kCAAA;EL+MV;AACF;AK7MQ;EAPJ;IAQQ,8BAAA;ELgNV;AACF;AK9MQ;EAXJ;IAYQ,0BAAA;ELiNV;AACF;AK9MI;EACI,8CAAA;ALgNR;AK9MQ;EAHJ;IAIQ,kCAAA;ELiNV;AACF;AK/MQ;EAPJ;IAQQ,8BAAA;ELkNV;AACF;AKhNQ;EAXJ;IAYQ,0BAAA;ELmNV;AACF;AK/MI;EACI,qBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;ALgNR;AK9MQ;EACI,aAAA;ALgNZ;AK5MQ;EACI,mBAAA;EACA,YAAA;AL8MZ;AK5MY;EACI,UAAA;AL8MhB;AK1MQ;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;AL4MZ;AK1MY;EARJ;IASQ,iBAAA;EL6Md;AACF;AK3MY;EACI,eAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;AL6MhB;AKzMY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;AL2MhB;AKzMgB;EACI,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AL2MpB;AKtMQ;EACI,eAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;ALwMZ;AKrMQ;EACI,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;ALuMZ;AKnMQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,UAAA;EACA,aAAA;ALqMZ;AKnMY;EACI,YAAA;EACA,iBAAA;EACA,+BAAA;ALqMhB;AKlMY;EACI,aAAA;ALoMhB;AKhMgB;EACI,aAAA;ALkMpB;AKhMgB;EACI,cAAA;EACA,eAAA;ALkMpB;AK7LQ;EACI,WAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;AL+LZ;AK7LY;EACI,cAAA;AL+LhB;AK3LQ;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AL6LZ;AKzLQ;EACI,eAAA;EACA,kBAAA;AL2LZ;AKzLY;EACI,aAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AL2LhB;AKzLgB;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;AL2LpB;AKvLoB;EACI,eAAA;EACA,cAAA;EACA,0BAAA;ALyLxB;AKvLwB;EALJ;IAMQ,eAAA;IACA,mBAAA;EL0L1B;AACF;AKxLwB;EACI,0BAAA;AL0L5B;AKnLY;EACI,+CAAA;ALqLhB;AKnLgB;EACI,wBAAA;ALqLpB;AKlLgB;EACI,eAAA;ALoLpB;AKjLgB;EAEI,wBAAA;ALkLpB;AK7KgB;EACI,cAAA;AL+KpB;AK7KgB;EACI,wBAAA;AL+KpB;AK3KY;EACI,SAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AL6KhB;AKxKY;EACI,aAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,gCAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;AL0KhB;AKvKY;EACI,iBAAA;EACA,eAAA;ALyKhB;AKtKY;EACI,UAAA;ALwKhB;AKtKgB;EACI,YAAA;EACA,aAAA;ALwKpB;AKlKY;EACI,eAAA;EACA,eAAA;ALoKhB;AKlKgB;EAJJ;IAKQ,eAAA;ELqKlB;AACF;AK7JY;EADR;IAEY,kCAAA;ELgKd;AACF;AK9JY;EALR;IAMY,8BAAA;ELiKd;AACF;AK/JY;EATR;IAUY,0BAAA;ELkKd;AACF;AK9JQ;EACI,mBAAA;ALgKZ;AK3JQ;EACI,cAAA;AL6JZ;AKrJI;EACI,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;ALuJR;AKrJQ;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;ALuJZ;AKrJY;EATJ;IAUQ,mBAAA;ELwJd;AACF;AKtJY;EACI,SAAA;EACA,UAAA;EACA,iBAAA;ALwJhB;AKrJY;EACI,aAAA;ALuJhB;AKpJY;EACI,eAAA;ALsJhB;AKlJY;EACI,cAAA;EACA,eAAA;ALoJhB;AKlJgB;EACI,WAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;ALoJpB;AKjJoB;EACI,iBAAA;EACA,gBAAA;ALmJxB;AK7IY;EACI,aAAA;EACA,gBAAA;EACA,oCAAA;EACA,eAAA;AL+IhB;AK7IgB;EANJ;IAOQ,eAAA;IACA,mBAAA;ELgJlB;AACF;AK7IY;EACI,aAAA;AL+IhB;AK3IQ;EACI,eAAA;AL6IZ;AK3IY;EAHJ;IAIQ,gBAAA;EL8Id;AACF;AK5IY;EACI,gBAAA;EACA,0BAAA;AL8IhB;AK5IgB;EAJJ;IAKQ,gBAAA;IACA,0BAAA;EL+IlB;AACF;AK3IQ;EACI,YAAA;EACA,eAAA;AL6IZ;AK1IQ;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;AL4IZ;AKxII;EACI,gBAAA;AL0IR;AKzIQ;EACI,gBAAA;EACA,iBAAA;AL2IZ;;AKpII;EACI,aAAA;EACA,aAAA;EACA,yBAAA;ALuIR;AKrIQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;ALuIZ;AKlIY;EAXJ;IAYQ,eAAA;IACA,SAAA;IACA,kBAAA;ELqId;AACF;AKlIQ;EACI,aAAA;ALoIZ;AKlIY;EACI,yBAAA;EACA,YAAA;ALoIhB;AK/HQ;EACI,eAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;ALiIZ;AK/HY;EANJ;IAOQ,eAAA;IACA,YAAA;IACA,iBAAA;IACA,YAAA;IACA,gBAAA;ELkId;AACF;AK9HQ;EACI,2BAAA;EACA,8BAAA;EACA,eAAA;ALgIZ;AK9HY;EALJ;IAMQ,kBAAA;ELiId;AACF;AK9HQ;EACI,4BAAA;EACA,+BAAA;EACA,iBAAA;ALgIZ;AK7HY;EANJ;IAOQ,kBAAA;ELgId;AACF;AM1rBA;EACI,kBAAA;AN4rBJ;;AMxrBA;EAEI,gBAAA;EACA,YAAA;EACA,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AN0rBJ;AMxrBI;EACI,mBAAA;AN0rBR;AMvrBI;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;ANyrBR;AMtrBI;EACI,UAAA;ANwrBR;AMrrBI;EACI,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;ANurBR;AMprBI;EACI,WAAA;ANsrBR;AMnrBI;EACI,WAAA;ANqrBR;AMlrBI;EACI,WAAA;ANorBR;AMjrBI;EJzCA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;AF6tBJ;AE3tBI;EACE,WAAA;EACA,yBAAA;EACA,2CAAA;AF6tBN;AE1tBI;EACE,eAAA;EACA,YAAA;AF4tBN;AMnsBQ;EACI,WAAA;EACA,iBAAA;ANqsBZ;AMlsBQ;EACI,WAAA;ANosBZ;;AOhwBI;EACI,aAAA;EACA,cAAA;EACA,mBAAA;APmwBR;AOjwBQ;EALJ;IAMQ,eAAA;IACA,mBAAA;EPowBV;AACF;AO/vBI;ELLA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EKJI,gBAAA;EACA,WAAA;EACA,kBAAA;AP4wBR;AExwBI;EACE,WAAA;EACA,yBAAA;EACA,2CAAA;AF0wBN;AEvwBI;EACE,eAAA;EACA,YAAA;AFywBN;AOjxBI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;APmxBR;AOjxBQ;EANJ;IAOQ,cAAA;EPoxBV;AACF;AOlxBQ;EACI,eAAA;EACA,mBAAA;APoxBZ;AOjxBQ;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;APmxBZ;AOjxBY;EACI,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;APmxBhB;AO/wBI;EACI,aAAA;EACA,WAAA;EACA,iBAAA;EACA,SAAA;APixBR;AO9wBQ;EAPJ;IAQQ,cAAA;EPixBV;AACF;;AOzwBI;EADJ;IAEQ,WAAA;EP6wBN;AACF;;AOzwBA;EACI,gBAAA;EACA,aAAA;AP4wBJ;AOzwBI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AP2wBR;AOxwBI;EACI,aAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AP0wBR;AOvwBQ;EACI,UAAA;EACA,mBAAA;APywBZ;AOtwBQ;EACI,gBAAA;APwwBZ;AOnwBI;ELjGA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EKwFI,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;APgxBR;AE/2BI;EACE,WAAA;EACA,yBAAA;EACA,2CAAA;AFi3BN;AE92BI;EACE,eAAA;EACA,YAAA;AFg3BN;AOvxBQ;EAbJ;IAcQ,eAAA;EP0xBV;AACF;AOxxBQ;EACI,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;AP0xBZ;AOtxBI;EACI,aAAA;EACA,eAAA;APwxBR;AOpxBQ;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;APsxBZ;AOpxBY;EACI,gBAAA;EACA,WAAA;EACA,iBAAA;APsxBhB;;AOhxBA;EACI,8BAAA;APmxBJ;;AO/wBA;EACI,aAAA;EACA,eAAA;APkxBJ;AOhxBI;EACI,cAAA;EACA,WAAA;EACA,aAAA;APkxBR;AOjxBQ;EACI,WAAA;EACA,iBAAA;APmxBZ;AOhxBI;EACI,cAAA;EACA,WAAA;APkxBR;;AO9wBA;EACI,aAAA;EACA,cAAA;APixBJ;AOhxBI;EAHJ;IAIQ,aAAA;EPmxBN;AACF;AOjxBI;EAPJ;IAQQ,aAAA;EPoxBN;AACF;AOlxBI;EAXJ;IAYQ,aAAA;EPqxBN;AACF;;AOlxBA;EACI,mBAAA;APqxBJ;AOnxBI;EAHJ;IAKQ,cAAA;IACA,WAAA;IACA,kBAAA;IACA,mBAAA;EPqxBN;AACF;AOnxBI;EAXJ;IAYQ,cAAA;IACA,WAAA;IACA,kBAAA;EPsxBN;AACF;AOpxBI;EAjBJ;IAkBQ,cAAA;IACA,WAAA;IACA,kBAAA;EPuxBN;AACF;AOlxBI;EACI,aAAA;EACA,uBAAA;EACA,qBAAA;APoxBR;AOjxBI;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;APmxBR;;AQv/BA;ENKI,iBAAA;EACA,YAAA;AFs/BJ;AQz/BI;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AR2/BR;AQx/BI;ENDA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EMRI,gBAAA;EACA,cAAA;ARqgCR;AE5/BI;EACE,WAAA;EACA,yBAAA;EACA,2CAAA;AF8/BN;AE3/BI;EACE,eAAA;EACA,YAAA;AF6/BN;AQ1gCI;EAlBJ;IAmBQ,eAAA;IACA,iBAAA;IACA,WAAA;IACA,SAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;ER6gCN;EQ5gCM;IACI,cAAA;ER8gCV;AACF","sourcesContent":["  /* open-sans-300 - latin */\n  @font-face {\n    font-display: swap; \n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: 300;\n    src: url('../../public/assets/fonts/open-sans-v35-latin-300.woff2') format('woff2'); \n  }\n\n  /* open-sans-regular - latin */\n  @font-face {\n    font-display: swap;\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: 400;\n    src: url('../../public/assets/fonts/open-sans-v35-latin-regular.woff2') format('woff2'); \n  }\n\n  /* open-sans-500 - latin */\n  @font-face {\n    font-display: swap; \n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: 600;\n    src: url('../../public/assets/fonts/open-sans-v35-latin-600.woff2') format('woff2'); \n  }\n\n  /* open-sans-700 - latin */\n  @font-face {\n    font-display: swap; \n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: 700;\n    src: url('../../public/assets/fonts/open-sans-v35-latin-700.woff2') format('woff2'); \n  }","/* open-sans-300 - latin */\n@font-face {\n  font-display: swap;\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 300;\n  src: url(\"../../public/assets/fonts/open-sans-v35-latin-300.woff2\") format(\"woff2\");\n}\n/* open-sans-regular - latin */\n@font-face {\n  font-display: swap;\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"../../public/assets/fonts/open-sans-v35-latin-regular.woff2\") format(\"woff2\");\n}\n/* open-sans-500 - latin */\n@font-face {\n  font-display: swap;\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 600;\n  src: url(\"../../public/assets/fonts/open-sans-v35-latin-600.woff2\") format(\"woff2\");\n}\n/* open-sans-700 - latin */\n@font-face {\n  font-display: swap;\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"../../public/assets/fonts/open-sans-v35-latin-700.woff2\") format(\"woff2\");\n}\nheader {\n  max-width: 1270px;\n  margin: auto;\n}\nheader .inner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n@media (max-width: 1024px) {\n  header .inner {\n    padding: 0 20px;\n  }\n}\nheader .inner .logo img {\n  max-height: 40px;\n  margin-top: 5px;\n}\nheader .inner .buttons a {\n  margin-left: 25px;\n}\nheader .inner .buttons a img {\n  height: 24px;\n  width: auto;\n  transition: all 0.2s ease-in-out;\n}\nheader .inner .buttons a:hover img {\n  opacity: 0.5;\n}\n\nbody {\n  font-family: \"Open Sans\";\n  box-sizing: border-box;\n  color: #17283f;\n  padding: 0;\n  margin: 0;\n}\nbody * {\n  box-sizing: border-box;\n}\n\n.cnt {\n  max-width: 1270px;\n  margin: auto;\n  padding: 40px 0;\n  padding-bottom: 0;\n}\n@media (max-width: 1024px) {\n  .cnt {\n    padding: 40px 20px;\n  }\n}\n.cnt .questions > .inner {\n  padding-right: 40px;\n}\n@media (max-width: 1024px) {\n  .cnt .questions > .inner {\n    padding-right: 0;\n  }\n}\n\n.steps {\n  background-color: #f9f5f0;\n  width: 100%;\n  padding: 20px 0;\n}\n@media (max-width: 1024px) {\n  .steps {\n    padding: 20px 20px;\n  }\n}\n.steps .inner {\n  max-width: 1270px;\n  margin: auto;\n}\n.steps .control {\n  display: flex;\n  align-items: center;\n  max-width: 700px;\n  margin: auto;\n}\n.steps .arrow {\n  flex: 0 0 10%;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n}\n.steps .arrow.disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.steps .arrow.disabled:hover {\n  opacity: 0.5;\n}\n.steps .arrow:hover {\n  opacity: 0.75;\n}\n.steps .arrow img {\n  max-height: 40px;\n  width: auto;\n}\n.steps .arrow.prev {\n  margin-bottom: -4px;\n}\n.steps .arrow.next {\n  transform: rotate(180deg);\n  margin-top: -4px;\n}\n.steps .numsteps {\n  flex: 1 0 50%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  max-width: 500px;\n  margin: auto;\n}\n.steps .numsteps:after {\n  position: absolute;\n  content: \"\";\n  width: 100%;\n  height: 4px;\n  background-color: white;\n}\n.steps .centre_block {\n  width: 55px;\n  height: 55px;\n  justify-content: center;\n  align-items: flex-start;\n  display: flex;\n}\n.steps .centre_block.selected .centre_icon_wrap {\n  background-color: #1a8992;\n}\n.steps .centre_block.selected .centre_icon_wrap p {\n  color: white;\n}\n.steps .centre_icon_wrap {\n  z-index: 5;\n  width: 55px;\n  height: 55px;\n  background-color: #fff;\n  border-radius: 50px;\n  justify-content: center;\n  align-items: center;\n  padding: 10px 10px;\n  display: flex;\n  position: relative;\n  box-shadow: 0 0 7px -1px rgba(51, 51, 51, 0.15);\n}\n.steps .span-bleu-small {\n  color: #1a8992;\n  text-align: left;\n  font-size: 2em;\n  font-weight: 700;\n  line-height: 1.5;\n}\n\n.step .separator {\n  display: grid;\n  grid-template-columns: 100px 1fr;\n  grid-gap: 30px;\n}\n@media (max-width: 1024px) {\n  .step .separator {\n    grid-template-columns: 0px 1fr;\n  }\n}\n.step .separator .line {\n  border-top: 3px dashed #e0ddd8;\n  margin-bottom: 60px;\n}\n\n.questions {\n  display: grid;\n  grid-template-columns: 100px 1fr;\n  grid-gap: 30px;\n}\n@media (max-width: 1024px) {\n  .questions {\n    grid-template-columns: 1fr;\n  }\n}\n.questions .side {\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n.questions .side .label {\n  color: #e0ddd8;\n  transform: rotate(-90deg);\n  font-weight: bold;\n  font-size: 32px;\n  text-transform: uppercase;\n}\n@media (max-width: 1024px) {\n  .questions .side .label {\n    transform: rotate(0deg);\n  }\n}\n.questions .side .label.higher {\n  margin-left: -40px;\n}\n@media (max-width: 1024px) {\n  .questions .side .label.higher {\n    margin: 0%;\n  }\n}\n.questions .inner {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-gap: 30px;\n  margin-bottom: 60px;\n}\n@media (max-width: 1024px) {\n  .questions .inner {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n@media (max-width: 768px) {\n  .questions .inner {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 428px) {\n  .questions .inner {\n    grid-template-columns: 1fr;\n  }\n}\n.questions.five .inner {\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n}\n@media (max-width: 1024px) {\n  .questions.five .inner {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n@media (max-width: 768px) {\n  .questions.five .inner {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media (max-width: 428px) {\n  .questions.five .inner {\n    grid-template-columns: 1fr;\n  }\n}\n.questions.six .inner {\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;\n}\n@media (max-width: 1024px) {\n  .questions.six .inner {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n@media (max-width: 768px) {\n  .questions.six .inner {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media (max-width: 428px) {\n  .questions.six .inner {\n    grid-template-columns: 1fr;\n  }\n}\n.questions .question {\n  display: inline-block;\n  margin-bottom: 0px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  position: relative;\n}\n.questions .question:hover {\n  opacity: 0.75;\n}\n.questions .question.selected {\n  background: #1a8992;\n  color: white;\n}\n.questions .question.selected:hover {\n  opacity: 1;\n}\n.questions .question .image {\n  width: 100%;\n  position: relative;\n  min-height: 200px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  border-radius: 10px;\n}\n@media (max-width: 1280px) {\n  .questions .question .image {\n    min-height: 160px;\n  }\n}\n.questions .question .image img {\n  max-width: 100%;\n  border-radius: 10px;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.questions .question .image .title-holder {\n  position: absolute;\n  top: 0;\n  left: 0;\n  text-align: center;\n  width: 100%;\n}\n.questions .question .image .title-holder h4 {\n  background: white;\n  display: inline-block;\n  font-size: 14px;\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-weight: 600;\n}\n.questions .question > img {\n  max-width: 100%;\n  border-radius: 10px;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.questions .question h4 {\n  margin: 0;\n  padding: 2px 6px;\n  font-weight: 500;\n  position: absolute;\n  background: #fff;\n  border-radius: 4px;\n  top: 6px;\n  left: 6px;\n  font-weight: 600;\n  font-size: 14px;\n}\n.questions .question .mark {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background: white;\n  padding: 5px;\n  border-bottom-left-radius: 10px;\n  z-index: 6;\n  display: none;\n}\n.questions .question .mark img {\n  height: 26px;\n  background: white;\n  border-bottom-left-radius: 10px;\n}\n.questions .question .mark .close {\n  display: none;\n}\n.questions .question .mark:hover .sqm {\n  display: none;\n}\n.questions .question .mark:hover .close {\n  display: block;\n  cursor: pointer;\n}\n.questions .question .subitems {\n  width: 100%;\n  font-size: 12px;\n  display: none;\n  padding: 0;\n}\n.questions .question .subitems.active {\n  display: block;\n}\n.questions .question .selectedroom {\n  position: absolute;\n  top: 35px;\n  left: 6px;\n  background: #fff;\n  padding: 3px;\n  z-index: 2;\n  border-radius: 4px;\n  font-size: 10px;\n}\n.questions .question.sqmselect {\n  cursor: default;\n  position: relative;\n}\n.questions .question.sqmselect .roomselector {\n  display: none;\n  background: white;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  border-radius: 10px;\n  text-align: center;\n  font-size: 13px;\n  padding: 20px;\n}\n.questions .question.sqmselect .roomselector .title {\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: bold;\n}\n.questions .question.sqmselect .roomselector .rooms .room {\n  cursor: pointer;\n  padding: 2px 0;\n  text-transform: capitalize;\n}\n@media (max-width: 1024px) {\n  .questions .question.sqmselect .roomselector .rooms .room {\n    font-size: 18px;\n    padding-bottom: 5px;\n  }\n}\n.questions .question.sqmselect .roomselector .rooms .room:hover {\n  text-decoration: underline;\n}\n.questions .question.sqmselect.hasroom {\n  box-shadow: 0 0 7px -1px rgba(51, 51, 51, 0.15);\n}\n.questions .question.sqmselect.hasroom .roomselector {\n  display: none !important;\n}\n.questions .question.sqmselect.hasroom .image {\n  cursor: default;\n}\n.questions .question.sqmselect.hasroom .message {\n  display: none !important;\n}\n.questions .question.sqmselect.hasselectionprocess .roomselector {\n  display: block;\n}\n.questions .question.sqmselect.hasselectionprocess .message {\n  display: none !important;\n}\n.questions .question.sqmselect .tip {\n  border: 0;\n  font-size: 10px;\n  background: #1a8992;\n  border-radius: 100%;\n  width: 12px;\n  height: 12px;\n  padding: 0;\n  margin-left: 5px;\n  color: white;\n}\n.questions .question.sqmselect .message {\n  display: flex;\n  background: white;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 3;\n  border-radius: 10px;\n  text-align: center;\n  font-size: 13px;\n  padding: 20px;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: all 0.2s ease-in-out;\n  pointer-events: none;\n  font-weight: bold;\n  max-height: 260px;\n}\n.questions .question.sqmselect .image {\n  min-height: 260px;\n  cursor: pointer;\n}\n.questions .question.sqmselect:hover {\n  opacity: 1;\n}\n.questions .question.sqmselect:hover .message {\n  opacity: 0.6;\n  display: flex;\n}\n.questions .question.sqmselect .rw-widget-input {\n  font-size: 12px;\n  min-width: 35px;\n}\n@media (max-width: 1024px) {\n  .questions .question.sqmselect .rw-widget-input {\n    font-size: 16px;\n  }\n}\n@media (max-width: 1024px) {\n  .questions.rooms .inner {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n@media (max-width: 768px) {\n  .questions.rooms .inner {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media (max-width: 428px) {\n  .questions.rooms .inner {\n    grid-template-columns: 1fr;\n  }\n}\n.questions.rooms .image {\n  border-radius: 10px;\n}\n.questions .hasnumbers .mark {\n  display: block;\n}\n.questions .sub {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  min-height: 60px;\n  flex-wrap: wrap;\n  padding: 6px;\n}\n.questions .sub .row {\n  width: 100%;\n  flex: 1 0 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 6px 6px;\n  font-size: 14px;\n}\n@media (max-width: 1024px) {\n  .questions .sub .row {\n    margin-bottom: 20px;\n  }\n}\n.questions .sub .row p {\n  margin: 0;\n  padding: 0;\n  line-height: 15px;\n}\n.questions .sub .row .title {\n  flex: 1 0 40%;\n}\n.questions .sub .row.wallsize {\n  flex-wrap: wrap;\n}\n.questions .sub .row .newline {\n  flex: 1 0 100%;\n  margin-top: 8px;\n}\n.questions .sub .row .newline .inpts {\n  width: 100%;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n}\n.questions .sub .row .newline .inpts strong {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.questions .sub .row.spoiler {\n  display: flex;\n  overflow: hidden;\n  transition: opacity 0.3s ease-in-out;\n  font-size: 13px;\n}\n@media (max-width: 1024px) {\n  .questions .sub .row.spoiler {\n    font-size: 14px;\n    padding-bottom: 0px;\n  }\n}\n.questions .sub .row.hidden {\n  display: none;\n}\n.questions .sub .rw-number-picker {\n  max-width: 80px;\n}\n@media (max-width: 1024px) {\n  .questions .sub .rw-number-picker {\n    max-width: 130px;\n  }\n}\n.questions .sub .rw-number-picker .rw-widget-picker {\n  min-height: 30px;\n  grid-template: 1fr/1fr 2em;\n}\n@media (max-width: 1024px) {\n  .questions .sub .rw-number-picker .rw-widget-picker {\n    min-height: 40px;\n    grid-template: 1fr/1fr 3em;\n  }\n}\n.questions .sub h4 {\n  padding: 0px;\n  font-size: 16px;\n}\n.questions .sub .right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n}\n.questions .sqm {\n  max-height: 30px;\n}\n.questions .sqm.small {\n  max-height: 20px;\n  margin-right: 5px;\n}\n\n.inputs.noradio {\n  display: flex;\n  flex: 1 0 12%;\n  justify-content: flex-end;\n}\n.inputs.noradio label {\n  font-size: 12px;\n  line-height: 12px;\n  background: #fff;\n  padding: 2px 6px;\n  border: 1px solid #1a8992;\n  cursor: pointer;\n}\n@media (max-width: 1024px) {\n  .inputs.noradio label {\n    font-size: 18px;\n    border: 0;\n    border-radius: 8px;\n  }\n}\n.inputs.noradio input[type=radio] {\n  display: none;\n}\n.inputs.noradio input[type=radio]:checked + label {\n  background-color: #1a8992;\n  color: white;\n}\n.inputs.noradio .smallicon {\n  max-width: 20px;\n  padding: 2px;\n  margin-right: 4px;\n  opacity: 0.6;\n}\n@media (max-width: 1024px) {\n  .inputs.noradio .smallicon {\n    max-width: 30px;\n    padding: 2px;\n    margin-right: 6px;\n    opacity: 0.6;\n    margin-top: -8px;\n  }\n}\n.inputs.noradio > div:nth-child(2) label {\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n  border-right: 0;\n}\n@media (max-width: 1024px) {\n  .inputs.noradio > div:nth-child(2) label {\n    border-radius: 8px;\n  }\n}\n.inputs.noradio > div:last-child label {\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  border-left: none;\n}\n@media (max-width: 1024px) {\n  .inputs.noradio > div:last-child label {\n    border-radius: 8px;\n  }\n}\n.step-form {\n  text-align: center;\n}\n\n.form {\n  max-width: 600px;\n  margin: auto;\n  box-shadow: 0 0 7px -1px rgba(51, 51, 51, 0.15);\n  padding: 30px;\n  border-radius: 10px;\n  margin-top: 40px;\n  text-align: left;\n  margin-bottom: 60px;\n  background: #f9f5f0;\n}\n.form > div {\n  margin-bottom: 10px;\n}\n.form label {\n  width: 100%;\n  display: inline-block;\n  margin-bottom: 5px;\n}\n.form .error {\n  color: red;\n}\n.form input, .form select, .form textarea {\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 10px;\n  margin-bottom: 10px;\n}\n.form input {\n  width: 100%;\n}\n.form select {\n  width: 100%;\n}\n.form textarea {\n  width: 100%;\n}\n.form button {\n  color: #f8f9fb;\n  white-space: nowrap;\n  background-color: #205e63;\n  border-radius: 3px;\n  margin: 0;\n  padding: 10px 20px;\n  font-size: 15px;\n  font-weight: 600;\n  border: 0;\n  line-height: 1.5;\n  transition: all 0.3s ease-in-out;\n  cursor: pointer;\n}\n.form button:hover {\n  color: #fff;\n  background-color: #10383b;\n  box-shadow: 0 1px 8px rgba(57, 64, 72, 0.4);\n}\n.form button.disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n.form .radios input {\n  width: auto;\n  margin-left: 10px;\n}\n.form .radios label {\n  width: auto;\n}\n\n.pdf .elements {\n  display: flex;\n  grid-gap: 30px;\n  margin-bottom: 60px;\n}\n@media (max-width: 1024px) {\n  .pdf .elements {\n    flex-wrap: wrap;\n    margin-bottom: 10px;\n  }\n}\n.pdf .button {\n  color: #f8f9fb;\n  white-space: nowrap;\n  background-color: #205e63;\n  border-radius: 3px;\n  margin: 0;\n  padding: 10px 20px;\n  font-size: 15px;\n  font-weight: 600;\n  border: 0;\n  line-height: 1.5;\n  transition: all 0.3s ease-in-out;\n  cursor: pointer;\n  max-width: 180px;\n  margin: 0px;\n  text-align: center;\n}\n.pdf .button:hover {\n  color: #fff;\n  background-color: #10383b;\n  box-shadow: 0 1px 8px rgba(57, 64, 72, 0.4);\n}\n.pdf .button.disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n.pdf .message {\n  flex: 1 0 30%;\n  font-size: 14px;\n  background: #f9f5f0;\n  padding: 30px;\n}\n@media (max-width: 1024px) {\n  .pdf .message {\n    flex: 1 0 100%;\n  }\n}\n.pdf .message img {\n  max-width: 100%;\n  border-radius: 10px;\n}\n.pdf .message button {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.pdf .message button img {\n  max-height: 20px;\n  margin-right: 5px;\n  width: auto;\n  filter: invert(1);\n}\n.pdf iframe {\n  flex: 1 0 60%;\n  width: 100%;\n  min-height: 600px;\n  border: 0;\n}\n@media (max-width: 1024px) {\n  .pdf iframe {\n    flex: 1 0 100%;\n  }\n}\n\n@media (max-width: 1024px) {\n  .popup-content {\n    width: 100%;\n  }\n}\n\n.modl {\n  min-height: 40vh;\n  padding: 30px;\n}\n.modl .close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  font-size: 32px;\n  z-index: 22;\n  line-height: 12px;\n}\n.modl .dates {\n  display: flex;\n  justify-content: flex-start;\n  align-content: flex-start;\n  column-gap: 20px;\n}\n.modl .dates .rw-date-picker {\n  width: 40%;\n  margin-bottom: 20px;\n}\n.modl .dates .rw-time-input {\n  max-height: 40px;\n}\n.modl .button {\n  color: #f8f9fb;\n  white-space: nowrap;\n  background-color: #205e63;\n  border-radius: 3px;\n  margin: 0;\n  padding: 10px 20px;\n  font-size: 15px;\n  font-weight: 600;\n  border: 0;\n  line-height: 1.5;\n  transition: all 0.3s ease-in-out;\n  cursor: pointer;\n  max-width: 280px;\n  margin: 0px;\n  text-align: center;\n  display: inline-block;\n  margin-right: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  max-height: 42px;\n  margin-top: 20px;\n}\n.modl .button:hover {\n  color: #fff;\n  background-color: #10383b;\n  box-shadow: 0 1px 8px rgba(57, 64, 72, 0.4);\n}\n.modl .button.disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n@media (max-width: 1024px) {\n  .modl .button {\n    font-size: 13px;\n  }\n}\n.modl .button img {\n  max-height: 20px;\n  margin-right: 5px;\n  width: auto;\n  filter: invert(1);\n}\n.modl .buttons {\n  display: flex;\n  flex-wrap: wrap;\n}\n.modl p a {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  text-decoration: none;\n}\n.modl p a img {\n  max-height: 20px;\n  width: auto;\n  margin-right: 6px;\n}\n\n.popup-overlay {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.pdf-viewer {\n  display: flex;\n  flex-wrap: wrap;\n}\n.pdf-viewer .ui {\n  display: block;\n  width: 100%;\n  padding: 20px;\n}\n.pdf-viewer .ui textarea {\n  width: 100%;\n  min-height: 100px;\n}\n.pdf-viewer .pdf-window {\n  display: block;\n  width: 100%;\n}\n\n.pdf-window {\n  flex: 1 0 70%;\n  display: block;\n}\n@media (max-width: 1024px) {\n  .pdf-window {\n    display: none;\n  }\n}\n@media all and (device-width: 1024px) {\n  .pdf-window {\n    display: none;\n  }\n}\n@media all and (device-width: 768px) {\n  .pdf-window {\n    display: none;\n  }\n}\n\n.pdf-download {\n  margin-bottom: 30px;\n}\n@media (max-width: 1024px) {\n  .pdf-download {\n    display: block;\n    width: 100%;\n    text-align: center;\n    margin-bottom: 60px;\n  }\n}\n@media all and (device-width: 1024px) {\n  .pdf-download {\n    display: block;\n    width: 100%;\n    text-align: center;\n  }\n}\n@media all and (device-width: 768px) {\n  .pdf-download {\n    display: block;\n    width: 100%;\n    text-align: center;\n  }\n}\n.pdf-download a {\n  display: flex;\n  justify-content: center;\n  text-decoration: none;\n}\n.pdf-download img {\n  max-height: 50px;\n  border-radius: 6px;\n  margin-right: 20px;\n}\n\n.bottom-navigation {\n  max-width: 1270px;\n  margin: auto;\n}\n.bottom-navigation .control {\n  display: flex;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 30px;\n}\n.bottom-navigation .button {\n  color: #f8f9fb;\n  white-space: nowrap;\n  background-color: #205e63;\n  border-radius: 3px;\n  margin: 0;\n  padding: 10px 20px;\n  font-size: 15px;\n  font-weight: 600;\n  border: 0;\n  line-height: 1.5;\n  transition: all 0.3s ease-in-out;\n  cursor: pointer;\n  max-width: 300px;\n  margin: 0 14px;\n}\n.bottom-navigation .button:hover {\n  color: #fff;\n  background-color: #10383b;\n  box-shadow: 0 1px 8px rgba(57, 64, 72, 0.4);\n}\n.bottom-navigation .button.disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n@media (max-width: 1024px) {\n  .bottom-navigation {\n    position: fixed;\n    background: white;\n    width: 100%;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .bottom-navigation .control {\n    margin: 20px 0;\n  }\n}","header {\n    @include layout;\n\n    .inner {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        @media (max-width: $mobile) {\n            padding: 0 20px;\n        }\n\n        .logo {\n            img {\n                max-height: 40px;\n                margin-top: 5px;\n            }\n        }\n\n        .buttons {\n            a {\n                margin-left: 25px;\n                img {\n                    height: 24px;\n                    width: auto;\n                    transition: all 0.2s ease-in-out;\n                }\n\n                &:hover {\n                    img {\n                        opacity: 0.5;\n                    }\n                }\n            }\n        }\n    }\n}","$mobile: 1024px;\n$mobilexs: 768px;\n$mobilexxs: 428px;\n\n@mixin layout {\n    max-width: 1270px;\n    margin: auto;\n  }\n\n@mixin button {\n    color: #f8f9fb;\n    white-space: nowrap;\n    background-color: #205e63;\n    border-radius: 3px;\n    margin: 0;\n    padding: 10px 20px;\n    font-size: 15px;\n    font-weight: 600;\n    border: 0;\n    line-height: 1.5;\n    transition: all .3s ease-in-out;\n    cursor: pointer;\n\n    &:hover {\n      color: #fff;\n      background-color: #10383b;\n      box-shadow: 0 1px 8px rgba(57,64,72,.4);\n    }\n\n    &.disabled {\n      cursor: default;\n      opacity: .5;\n    }\n}","body {\n    font-family: 'Open Sans';\n    box-sizing: border-box;\n    color: #17283f;\n    padding: 0;\n    margin: 0;\n\n    & * {\n        box-sizing: border-box;\n    }\n}\n\n.cnt {\n    @include layout;\n    padding: 40px 0;\n    padding-bottom: 0;\n\n    @media (max-width: $mobile) {\n        padding: 40px 20px;\n    }\n\n    .questions > .inner {\n        padding-right: 40px;\n\n        @media (max-width: 1024px) {\n            padding-right: 0;\n        }\n    }\n}\n",".steps {\n    background-color: #f9f5f0;\n    width: 100%;\n    padding: 20px 0;\n\n    @media (max-width: $mobile) {\n        padding: 20px 20px;\n    }\n\n    .inner {\n        @include layout;\n    }\n\n\n    .control {\n        display: flex;\n        align-items: center;\n        max-width: 700px;\n        margin: auto;\n    }\n\n    .arrow {\n        flex: 0 0 10%;\n        cursor: pointer;\n        transition: all 0.3s ease-in-out;\n\n        &.disabled {\n            opacity: 0.5;\n            cursor: default;\n\n            &:hover {\n                opacity: 0.5;\n            }\n        }\n\n        &:hover {\n            opacity: 0.75;\n        }\n        \n\n        img {\n            max-height: 40px;\n            width: auto;\n   \n        }\n\n        &.prev {\n            margin-bottom: -4px;\n        }\n\n        &.next {\n            transform: rotate(180deg);\n            margin-top: -4px;\n        }\n    }\n\n    .numsteps {\n        flex: 1 0 50%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        position: relative;\n        max-width: 500px;\n        margin: auto;\n\n        &:after {\n            position: absolute;\n            content: '';\n            width: 100%;\n            height: 4px;\n            background-color: white;\n        }\n    }\n\n    .centre_block {\n        width: 55px;\n        height: 55px;\n        justify-content: center;\n        align-items: flex-start;\n        display: flex;\n\n        &.selected {\n            .centre_icon_wrap {\n                \n                background-color: #1a8992;\n                p {\n                    color: white;\n                }\n            }\n        }\n    }\n\n    .centre_icon_wrap {\n        z-index: 5;\n        width: 55px;\n        height: 55px;\n        background-color: #fff;\n        border-radius: 50px;\n        justify-content: center;\n        align-items: center;\n        padding: 10px 10px;\n        display: flex;\n        position: relative;\n        box-shadow: 0 0 7px -1px rgba(51,51,51,.15);\n    }\n\n    .span-bleu-small {\n        color: #1a8992;\n        text-align: left;\n        font-size: 2em;\n        font-weight: 700;\n        line-height: 1.5;\n    }\n  \n}\n\n.step {\n    .separator {\n        display: grid;\n        grid-template-columns: 100px 1fr;\n        grid-gap: 30px;\n\n        @media (max-width: $mobile) {\n            grid-template-columns: 0px 1fr;\n        }\n\n        \n        .line {\n            border-top: 3px dashed #e0ddd8;\n            margin-bottom: 60px;\n        }\n    }\n}",".questions {\n\n    display: grid;\n    grid-template-columns: 100px 1fr;\n    grid-gap: 30px;\n\n    @media (max-width: $mobile) {\n        grid-template-columns: 1fr;\n    }\n\n    .side {\n        display: flex;\n        align-content: center;\n        align-items: center;\n\n        .label {\n            color: #e0ddd8;\n            transform: rotate(-90deg);\n            font-weight: bold;\n            font-size: 32px;\n            text-transform: uppercase;\n\n            @media (max-width: $mobile) {\n                transform: rotate(0deg);\n            }\n\n            &.higher {\n                margin-left: -40px;\n\n                @media (max-width: $mobile) {\n                    margin: 0%;\n                }\n            }\n        }\n    }\n\n    .inner {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr 1fr;\n        grid-gap: 30px;\n        margin-bottom: 60px;\n\n        @media (max-width: $mobile) {\n            grid-template-columns: 1fr 1fr 1fr;\n        }\n\n        @media (max-width: $mobilexs) {\n            grid-template-columns: 1fr;\n        }\n\n        @media (max-width: $mobilexxs) {\n            grid-template-columns: 1fr;\n        }\n    }\n\n    &.five .inner {\n        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;  \n\n        @media (max-width: $mobile) {\n            grid-template-columns: 1fr 1fr 1fr;\n        }\n\n        @media (max-width: $mobilexs) {\n            grid-template-columns: 1fr 1fr;\n        }\n\n        @media (max-width: $mobilexxs) {\n            grid-template-columns: 1fr;\n        }\n    }\n\n    &.six .inner {\n        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;   \n\n        @media (max-width: $mobile) {\n            grid-template-columns: 1fr 1fr 1fr;\n        }\n\n        @media (max-width: $mobilexs) {\n            grid-template-columns: 1fr 1fr;\n        }\n\n        @media (max-width: $mobilexxs) {\n            grid-template-columns: 1fr;\n        }\n    }\n\n\n    .question {\n        display: inline-block;\n        margin-bottom: 0px;\n       \n        border-radius: 10px;\n        cursor: pointer;\n        transition: all 0.3s ease-in-out;\n        position: relative;\n\n        &:hover {\n            opacity: 0.75;\n            \n        }\n\n        &.selected {\n            background: #1a8992;\n            color: white;\n\n            &:hover {\n                opacity: 1;\n            }\n        }\n\n        .image {\n            width: 100%;\n            position: relative;\n            min-height: 200px;\n            background-size: cover;\n            background-repeat: no-repeat;\n            border-radius: 10px;\n\n            @media (max-width: 1280px) {\n                min-height: 160px;\n            }\n\n            img {\n                max-width: 100%;\n                border-radius: 10px;\n                border-bottom-left-radius: 0;\n                border-bottom-right-radius: 0;\n\n            }\n\n            .title-holder {\n                position: absolute;\n                top: 0;\n                left: 0;\n                text-align: center;\n                width: 100%;\n\n                h4 {\n                    background: white;\n                    display: inline-block;\n                    font-size: 14px;\n                    padding: 3px 8px;\n                    border-radius: 4px;\n                    font-weight: 600;\n                }\n            }\n        }\n\n        & > img {\n            max-width: 100%;\n            border-radius: 10px;\n            border-bottom-left-radius: 0;\n            border-bottom-right-radius: 0;\n        }\n\n        h4 {\n            margin: 0;\n            padding: 2px 6px;\n            font-weight: 500;\n            position: absolute;\n            background: #fff;\n            border-radius: 4px;\n            top: 6px;\n            left: 6px;\n            font-weight: 600;\n            font-size: 14px;\n\n        }\n\n        .mark {\n            position: absolute;\n            top: 0;\n            right: 0;\n            background: white;\n            padding: 5px;\n            border-bottom-left-radius: 10px;\n            z-index: 6;\n            display: none;\n            \n            img {\n                height: 26px;\n                background: white;\n                border-bottom-left-radius: 10px;\n            }\n\n            .close {\n                display: none;\n            }\n\n            &:hover {\n                .sqm {\n                    display: none;\n                }\n                .close {\n                    display: block;\n                    cursor: pointer;\n                }\n            }\n        }\n\n        .subitems {\n            width: 100%;\n            font-size: 12px;\n            display: none;\n            padding: 0;\n\n            &.active {\n                display: block;\n            }\n        }\n\n        .selectedroom {\n            position: absolute;\n            top: 35px;\n            left: 6px;\n            background: #fff;\n            padding: 3px;\n            z-index: 2;\n            border-radius: 4px;\n            font-size: 10px;\n        }\n\n\n        &.sqmselect {\n            cursor: default;\n            position: relative;\n\n            .roomselector {\n                display: none;\n                background: white;\n                width: 100%;\n                height: 100%;\n                position: absolute;\n                top: 0;\n                left: 0;\n                z-index: 2;\n                border-radius: 10px;\n                text-align: center;\n                font-size: 13px;\n                padding: 20px;\n\n                .title {\n                    margin-bottom: 10px;\n                    font-size: 13px;\n                    font-weight: bold;\n                }\n\n                .rooms {\n                    .room {\n                        cursor: pointer;\n                        padding: 2px 0;\n                        text-transform: capitalize;\n\n                        @media (max-width: $mobile) {\n                            font-size: 18px;\n                            padding-bottom: 5px;\n                        }\n\n                        &:hover {\n                            text-decoration: underline;\n                        }\n                    }\n                }\n            }\n\n\n            &.hasroom {\n                box-shadow: 0 0 7px -1px rgba(51, 51, 51, 0.15);\n                \n                .roomselector {\n                    display: none!important;\n                }\n\n                .image {\n                    cursor: default;\n                }\n\n                .message {\n                    \n                    display: none!important;\n                }\n            }\n\n            &.hasselectionprocess {\n                .roomselector {\n                    display: block;\n                }\n                .message {\n                    display: none!important;\n                }\n            }\n\n            .tip {\n                border: 0;\n                font-size: 10px;\n                background: #1a8992;\n                border-radius: 100%;\n                width: 12px;\n                height: 12px;\n                padding: 0;\n                margin-left: 5px;\n                color: white;\n            }\n\n            \n\n            .message {\n                display: flex;       \n                background: white;\n                width: 100%;\n                height: 100%;\n                position: absolute;\n                top: 0;\n                left: 0;\n                z-index: 3;\n                border-radius: 10px;\n                text-align: center;\n                font-size: 13px;\n                padding: 20px;\n                align-items: center;\n                justify-content: center;\n                opacity: 0;\n                transition: all 0.2s ease-in-out;\n                pointer-events: none;\n                font-weight: bold;\n                max-height: 260px;\n            }\n            \n            .image {\n                min-height: 260px;\n                cursor: pointer;\n            }\n\n            &:hover {\n                opacity: 1;\n\n                .message {\n                    opacity: 0.6;\n                    display: flex;\n                }\n                \n            }\n\n\n            .rw-widget-input {\n                font-size: 12px;\n                min-width: 35px;\n\n                @media (max-width: $mobile) {\n                    font-size: 16px;\n                }\n            }\n        }\n    }\n\n    &.rooms {\n\n    .inner {\n            @media (max-width: $mobile) {\n                grid-template-columns: 1fr 1fr 1fr;\n            }\n\n            @media (max-width: $mobilexs) {\n                grid-template-columns: 1fr 1fr;\n            }\n\n            @media (max-width: $mobilexxs) {\n                grid-template-columns: 1fr;\n            }\n        }\n\n\n        .image {\n            border-radius: 10px;\n        }\n    }\n\n    .hasnumbers {\n        .mark {\n            display: block;\n        }    \n        \n    }\n\n  \n\n\n    .sub {\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-between;\n        min-height: 60px;\n        flex-wrap: wrap;\n        padding: 6px;\n\n        .row {\n            width: 100%;\n            flex: 1 0 100%;\n            display: flex;\n            align-items: center;\n            justify-content: flex-start;\n            padding: 6px 6px;\n            font-size: 14px;\n\n            @media (max-width: $mobile) {\n                margin-bottom: 20px;\n            }\n\n            p {\n                margin: 0;\n                padding: 0;\n                line-height: 15px;\n            }\n\n            .title {\n                flex: 1 0 40%;\n            }\n\n            &.wallsize {\n                flex-wrap: wrap;\n            }\n            \n\n            .newline {\n                flex: 1 0 100%;\n                margin-top: 8px;\n                \n                .inpts {\n                    width: 100%;\n                    display: flex;\n                    align-content: center;\n                    align-items: center;\n                    justify-content: center;\n                    \n\n                    strong {\n                        margin-right: 5px;\n                        margin-left: 5px;\n                    }\n                }\n            }\n\n\n            &.spoiler {\n                display: flex;\n                overflow: hidden;\n                transition: opacity 0.3s ease-in-out;\n                font-size: 13px;\n\n                @media (max-width: $mobile) {\n                    font-size: 14px;\n                    padding-bottom: 0px;\n                }\n            }\n\n            &.hidden {\n                display: none;\n            }\n        }\n\n        .rw-number-picker {\n            max-width: 80px;\n\n            @media (max-width: $mobile) {\n                max-width: 130px;\n            }\n\n            .rw-widget-picker {\n                min-height: 30px;\n                grid-template: 1fr/1fr 2em;\n\n                @media (max-width: $mobile) {\n                    min-height: 40px;\n                    grid-template: 1fr/1fr 3em;\n                }\n            }\n        }\n\n        h4 {\n            padding: 0px;\n            font-size: 16px;\n        }\n\n        .right {\n            display: flex;\n            align-items: center;\n            justify-content: flex-end;\n            width: 100%;\n        }\n    }\n\n    .sqm {\n        max-height: 30px;\n        &.small {\n            max-height: 20px;\n            margin-right: 5px;\n        }\n    }\n}\n\n\n.inputs {\n    &.noradio {\n        display: flex;\n        flex: 1 0 12%;\n        justify-content: flex-end;\n\n        label {\n            font-size: 12px;\n            line-height: 12px;\n            background: #fff;\n            padding: 2px 6px;\n            border: 1px solid #1a8992;\n            cursor: pointer;\n\n\n\n\n            @media (max-width: $mobile) {\n                font-size: 18px;\n                border: 0;\n                border-radius: 8px;\n            }\n        }\n\n        input[ type=\"radio\" ] {\n            display: none;\n\n            &:checked+label{  \n                background-color: #1a8992; \n                color: white;\n            } \n\n        }\n\n        .smallicon {\n            max-width: 20px;\n            padding: 2px;\n            margin-right: 4px;\n            opacity: 0.6;\n\n            @media (max-width: $mobile) {\n                max-width: 30px;\n                padding: 2px;\n                margin-right: 6px;\n                opacity: 0.6;\n                margin-top: -8px;\n            }\n        }\n\n\n        &>div:nth-child(2) label {\n            border-top-left-radius: 3px;\n            border-bottom-left-radius: 3px;\n            border-right: 0;\n\n            @media (max-width: $mobile) {\n                border-radius: 8px;\n            }\n        }\n\n        &>div:last-child label {\n            border-top-right-radius: 3px;\n            border-bottom-right-radius: 3px;\n            border-left: none;\n\n\n            @media (max-width: $mobile) {\n                border-radius: 8px;\n            }\n        }\n\n\n\n        &>div {\n            \n        }\n    }\n}",".step-form {\n    text-align: center;\n}\n\n\n.form {\n   \n    max-width: 600px;\n    margin: auto;\n    box-shadow: 0 0 7px -1px rgba(51, 51, 51, 0.15);\n    padding: 30px;\n    border-radius: 10px;\n    margin-top: 40px;\n    text-align: left;\n    margin-bottom: 60px;\n    background: #f9f5f0;\n\n    &>div {\n        margin-bottom: 10px;\n    }\n\n    label {\n        width: 100%;\n        display: inline-block;\n        margin-bottom: 5px;\n    }\n\n    .error {\n        color: red;\n    }\n\n    input,select,textarea {\n        width: 100%;\n        border: 1px solid #ccc;\n        border-radius: 5px;\n        padding: 10px;\n        margin-bottom: 10px;\n    }\n\n    input {\n        width: 100%;\n    }\n\n    select {\n        width: 100%;\n    }\n\n    textarea {\n        width: 100%;\n    }\n\n    button {\n        @include button;\n    }\n\n    .radios {\n        input {\n            width: auto;\n            margin-left: 10px;\n        }\n\n        label {\n            width: auto;\n        }\n    }\n\n}",".pdf {\n\n    .elements {\n        display: flex;\n        grid-gap: 30px;\n        margin-bottom: 60px;\n    \n        @media (max-width: $mobile) {\n            flex-wrap: wrap;\n            margin-bottom: 10px;\n        }\n    }\n \n\n\n    .button {\n        @include button;\n        max-width: 180px;\n        margin: 0px;\n        text-align: center;\n       \n    }\n\n    .message {\n        flex: 1 0 30%;\n        font-size: 14px;\n        background: #f9f5f0;\n        padding: 30px;\n\n        @media (max-width: $mobile) {\n            flex: 1 0 100%;\n        }\n\n        img {\n            max-width: 100%;\n            border-radius: 10px;\n        }\n\n        button {\n            display: flex;\n            align-items: center;\n            justify-content: flex-start;\n\n            img {\n                max-height: 20px;\n                margin-right: 5px;\n                width: auto;\n                filter: invert(1);\n            }\n        }\n    }\n    iframe {\n        flex: 1 0 60%;\n        width: 100%;\n        min-height: 600px;\n        border: 0;\n\n\n        @media (max-width: $mobile) {\n            flex: 1 0 100%;\n        }\n    }\n\n \n}\n\n\n.popup-content {\n    @media (max-width: $mobile) {\n        width: 100%;\n    }\n}\n\n\n.modl {\n    min-height: 40vh;\n    padding: 30px;\n\n\n    .close {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        cursor: pointer;\n        font-size: 32px;\n        z-index: 22;\n        line-height: 12px;\n    }\n\n    .dates {\n        display: flex;\n        justify-content: flex-start;\n        align-content: flex-start;\n        column-gap: 20px;\n\n\n        .rw-date-picker {\n            width: 40%;\n            margin-bottom: 20px;\n        } \n\n        .rw-time-input {\n            max-height: 40px;\n        }\n    }\n\n\n    .button {\n        @include button;\n        max-width: 280px;\n        margin: 0px;\n        text-align: center;\n        display: inline-block;\n        margin-right: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        max-height: 42px;\n        margin-top: 20px;\n\n        @media (max-width: $mobile) {\n            font-size: 13px;\n        }\n\n        img {\n            max-height: 20px;\n            margin-right: 5px;\n            width: auto;\n            filter: invert(1);\n        }\n    }\n\n    .buttons {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    p {\n        a {\n            display: flex;\n            align-items: center;\n            justify-content: flex-start;\n            text-decoration: none;\n\n            img {\n                max-height: 20px;\n                width: auto;\n                margin-right: 6px;\n            }\n        }\n    }\n}\n\n.popup-overlay {\n    background: rgba(0,0,0,.8);\n}\n\n\n.pdf-viewer {\n    display: flex;\n    flex-wrap: wrap;\n\n    .ui {\n        display: block;\n        width: 100%; \n        padding: 20px;\n        textarea {\n            width: 100%;\n            min-height: 100px;\n        }\n    }\n    .pdf-window {\n        display: block;\n        width: 100%;\n    }\n}\n\n.pdf-window {\n    flex: 1 0 70%;\n    display: block;\n    @media (max-width: $mobile) {\n        display: none;\n    }\n\n    @media all and (device-width: 1024px){\n        display: none;\n    }\n\n    @media all and (device-width: 768px) {\n        display: none;\n    }\n}\n\n.pdf-download {\n    margin-bottom: 30px;\n\n    @media (max-width: $mobile)\n     {\n        display: block;\n        width: 100%;\n        text-align: center;\n        margin-bottom: 60px;\n    }\n\n    @media all and (device-width: 1024px){\n        display: block;\n        width: 100%;\n        text-align: center;\n    }\n\n    @media all and (device-width: 768px) {\n        display: block;\n        width: 100%;\n        text-align: center;\n    }\n\n\n    \n\n    a {\n        display: flex;\n        justify-content: center;\n        text-decoration: none;\n    }\n\n    img {\n        max-height: 50px;\n        border-radius: 6px;\n        margin-right: 20px;\n    }\n}",".bottom-navigation {\n    @include layout;\n\n    .control {\n        display: flex;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-bottom: 30px;\n    }\n\n    .button {\n        @include button;\n        max-width: 300px;\n        margin: 0 14px;\n        \n    }\n\n    @media (max-width: $mobile) {\n        position: fixed;\n        background: white;\n        width: 100%;\n        bottom: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        .control {\n            margin: 20px 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
